<template>
  <div>
    <div class="flex justify-between mb-6">
      <SegmentSelector v-model="segment" />
    </div>

    <div class="relative mb-4 pb-2">
      <div class="absolute w-full h-full">
        <div class="w-2/3 h-full ml-auto">
          <XAxis :domain="[-100, 100]" class="w-full h-full text-gray-500" />
        </div>
      </div>

      <DivergingStackedBars
        bar-class="bg-primary"
        :data="barData"
        :color-classes="colors"
        :stacked="stacked"
      />
    </div>
  </div>
</template>

<script>
import DivergingStackedBars from "@/components/DivergingStackedBars";
import XAxis from "@/components/XAxis";
import data from "@/assets/data/data";
import IDS from "@/utils/ids";
import SegmentSelector from "@/components/SegmentSelector";
import { group, max } from "d3";

export default {
  components: {
    DivergingStackedBars,
    XAxis,
    SegmentSelector,
  },
  props: {
    question: {
      type: Number,
      required: true,
    },
    order: {
      type: Object,
      required: true,
    },
    colors: {
      type: Object,
      required: true,
    },
    defaultOrder: {
      type: String,
      default: "Muy bueno",
    },
  },
  data() {
    return {
      data: group(
        data[this.question].filter((e) => e[IDS.QUESTION_SUBNUMBER] === ""),
        (e) => e[IDS.QUESTION_OPTION]
      ),
      segment: "TOTAL",
      questionText: this.$t(`questions.${this.question}.question`),
      orderBy: this.defaultOrder,
      orderDir: true,
      stacked: 1,
      groupingOptions: [
        { name: "Agrupado", value: 1 },
        { name: "Separado", value: 0 },
      ],
      tooltip: {
        show: false,
        left: 0,
        top: 0,
        bottom: 0,
        html: "",
        title: "",
        target: null,
      },
    };
  },
  computed: {
    barData() {
      return Array.from(this.data, ([name, values]) => {
        const newValues = [];
        values.forEach((e) => {
          // very dirty trick... divide the NSNC option into two
          if (e[IDS.ANSWER] === IDS.NSNC) {
            // if (!newValues) {
            newValues.push({
              name: IDS.NSNC2,
              value: e[IDS[this.segment]] / 2,
            });

            newValues.push({
              name: e[IDS.ANSWER],
              value: e[IDS[this.segment]] / 2,
            });
          } else
            newValues.push({
              name: e[IDS.ANSWER],
              value: e[IDS[this.segment]],
            });
        });
        // console.log(newValues);

        newValues.sort((a, b) => {
          return this.order[b.name] - this.order[a.name];
        });

        return {
          name,
          values: newValues,
          // add the two top values for this chart and order by that result
          orderBy: values
            .filter((e) =>
              [IDS.TOTALMENTE_ACUERDO, IDS.DE_ACUERDO].includes(e[IDS.ANSWER])
            )
            .reduce((acc, b) => acc + b[IDS[this.segment]], 0),
        };
      }).sort((a, b) => {
        return (b.orderBy - a.orderBy) * (this.orderDir ? 1 : -1);
      });
    },
    axis() {
      return [0, 1, 2, 3].map((_, i) =>
        max(this.barData.map((e) => e.values[i].value))
      );
    },
  },
  methods: {
    setOrder(val) {
      if (val === this.orderBy) {
        this.orderDir = !this.orderDir;
      } else this.orderBy = val;
    },
  },
  watch: {
    segment(val) {
      this.$emit("changeSegment", val);
    },
  },
};
</script>
